import { SideBar } from '../../models/sideBar.model';
import { assets } from './assets.const';
import {
  calenderSubMenuConst,
  CommunicationSubmenuConst,
  ModuleConst,
  packagesandPromosConst,
  ResourceManagementConst,
  SubjectAndExpertiseConst,
  SupportConst,
  WorkFlowConst
} from './keys.constant';

export const sideBar: SideBar[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    img: assets.DashboardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },
  {
    label: 'Students',
    path: '/manage-students',
    img: assets.UsersIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Students
  },
  {
    label: 'Instructors',
    path: '/instructors',
    img: assets.tutorIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.TutorAndCounsellor
  },
  {
    label: 'Calendar & Sessions',
    path: '/manage-calender/sessions',
    img: assets.calenderIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.CalenderAndSession,
    subMenuItems: [
      {
        label: 'All Sessions',
        path: '/manage-calender/sessions',
        isSubMenu: false,
        sideBarId: +calenderSubMenuConst.AllSessions
      },
      {
        label: 'Session Categories',
        path: '/manage-calender/session-categories',
        isSubMenu: false,
        sideBarId: +calenderSubMenuConst.sessionTypes
      },
      {
        label: 'Scores & Ratings',
        path: '/manage-calender/scores-ratings',
        isSubMenu: false,
        sideBarId: +calenderSubMenuConst.scoreAndRatings
      },
      {
        label: 'Locations',
        path: '/manage-calender/locations',
        isSubMenu: false,
        sideBarId: +calenderSubMenuConst.locations
      },
      {
        label: 'Templates',
        path: '/manage-calender/templates',
        isSubMenu: false,
        sideBarId: +calenderSubMenuConst.templates
      }
    ]
  },
  {
    label: 'Packages & Promos',
    path: '/manage-packages',
    img: assets.packageIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.PackagesAndPromos,
    subMenuItems: [
      {
        label: 'Packages',
        path: '/manage-packages/packages',
        isSubMenu: false,
        sideBarId: +packagesandPromosConst.packages
      },
      {
        label: 'Promos',
        path: '/manage-packages/promos',
        isSubMenu: false,
        sideBarId: +packagesandPromosConst.promos
      }
    ]
  },
  {
    label: 'Subjects & Expertise',
    img: assets.subjectIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.SubjectAndExpertise,
    path: '/manage-subject-expertise',
    subMenuItems: [
      {
        label: 'Tutoring Subjects',
        path: '/manage-subject-expertise/subject/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.Subject
      },
      {
        label: 'Counseling Expertise',
        path: '/manage-subject-expertise/expertise/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.Expertise
      },
      {
        label: ' Study Levels',
        path: '/manage-subject-expertise/study-level/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.StudyLevels
      },
      {
        label: 'Curriculums',
        path: '/manage-subject-expertise/curriculums/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.Curriculums
      },
      {
        label: 'Majors',
        path: '/manage-subject-expertise/major/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.Majors
      },
      {
        label: 'Hobbies / Interests',
        path: '/manage-subject-expertise/hobbies/list/1',
        isSubMenu: false,
        sideBarId: +SubjectAndExpertiseConst.HobbiesAndInterest
      }

    ]
  },
  {
    label: 'Schools & Colleges',
    path: '/manage-schools-colleges',
    sideBarId: ModuleConst.SchoolAndColleges,
    img: assets.schoolIcon,
    isSubMenu: false
  },
  {
    label: 'Workflow',
    img: assets.workflowIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.WorkFlow,
    path: '/manage-workflow/stages',
    subMenuItems: [
      {
        label: 'Planners & Scores',
        path: '/manage-workflow/stages',
        isSubMenu: false,
        sideBarId: +WorkFlowConst.StagesAndScores
      },
      {
        label: 'College Application',
        path: '/manage-workflow/application',
        isSubMenu: false,
        sideBarId: +WorkFlowConst.CollegeApplication
      },
      {
        label: 'Tiers',
        path: '/manage-workflow/tiers',
        isSubMenu: false,
        sideBarId: +WorkFlowConst.Tiers
      },
      {
        label: 'Reports',
        path: '/manage-workflow/reports',
        isSubMenu: false,
        sideBarId: +WorkFlowConst.Reports
      },
      {
        label: 'Statuses',
        path: '/manage-workflow/statuses',
        isSubMenu: false,
        sideBarId: +WorkFlowConst.Statuses
      }
    ]
  },
  {
    label: 'Projects',
    path: '/manage-project',
    img: assets.projectIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Projects
  },

  {
    label: 'Resource Management',
    img: assets.CategoryIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.ResourceManagement,
    path: '/resource-management',
    subMenuItems: [
      {
        label: 'Files',
        path: '/resource-management/files',
        isSubMenu: false,
        sideBarId: +ResourceManagementConst.LearningResources
      },
      {
        label: 'Courses',
        path: '/resource-management/courses',
        isSubMenu: false,
        sideBarId: +ResourceManagementConst.Courses
      },
      {
        label: 'Articles & Guides',
        path: '/resource-management/articles',
        sideBarId: +ResourceManagementConst.Articles,
        isSubMenu: false
      },
      {
        label: 'Categories',
        path: '/manage-categories',
        isSubMenu: false,
        sideBarId: +ResourceManagementConst.ManageCategories
      }
    ]
  },
  {
    label: 'Billing & Invoices',
    path: '/billing-invoices',
    img: assets.payrollIcon,
    sideBarId: ModuleConst.BillingAndInvoice,
    isSubMenu: false
  },
  {
    label: 'Payroll',
    path: '/manage-payroll',
    img: assets.RevenueIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Payroll
  },
  {
    label: 'Communication',
    img: assets.communicationIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.Communication,
    path: '/manage-communication/templates',
    subMenuItems: [
      // {
      //   label: 'Templates',
      //   path: '/manage-communication/templates',
      //   isSubMenu: false,
      //   sideBarId: +CommunicationSubmenuConst.Templates
      // },
      {
        label: 'Messaging',
        path: '/manage-communication/messaging',
        isSubMenu: false,
        sideBarId: +CommunicationSubmenuConst.Messaging
      },
      {
        label: 'Notifications',
        path: '/manage-communication/notification',
        isSubMenu: false,
        sideBarId: +CommunicationSubmenuConst.Notification
      }
    ]
  },
  {
    label: 'Support',
    path: '/manage-customer-support',
    img: assets.ReportIcon,
    sideBarId: ModuleConst.Support,
    isSubMenu: true,
    subMenuItems: [
      {
        label: 'Lists',
        path: '/manage-customer-support/lists',
        isSubMenu: false,
        sideBarId: +SupportConst.Lists
      },
      {
        label: 'Tickets',
        path: '/manage-customer-support/tickets',
        isSubMenu: false,
        sideBarId: +SupportConst.Tickets
      }
    ]
  },
  {
    label: 'Reports & Analytics',
    path: '/reports-and-analytics',
    img: assets.AnalyticIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.AnalyticsReports
  },
  {
    label: 'Users',
    path: '/manage-user-roles',
    img: assets.SubAdminIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.ManageUsers,
    subMenuItems: [
      // {
      //   label: 'Manage Users',
      //   path: '/manage-user-roles',
      //   isSubMenu: false,
      //   sideBarId: +'01'
      // },
      {
        label: 'Users',
        path: '/manage-subadmin',
        isSubMenu: false,
        sideBarId: +'01'
      },
      {
        label: 'Logs',
        path: '/manage-userlogs',
        isSubMenu: false,
        sideBarId: +'02'
      }
    ]
  }
  // {
  //   label: 'Manage Sub-Admin',
  //   path: '/manage-subadmin',
  //   img: assets.SubAdminIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.ManageSubAdmin
  // }
  // {
  //   label: 'User Logs',
  //   path: '/manage-userlogs',
  //   img: assets.SubAdminIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.UserLogs
  // },
  // {
  //   label: 'Manage CMS',
  //   path: '/manage-cms',
  //   img: assets.CmsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.ManageCMS
  // }

  // {
  //   label: 'Manage Settings',
  //   path: '/manage-settings',
  //   img: assets.settingIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.ManageSettings
  // }
];
